<script>
import { notify } from '@/helpers/notify'

export default {
    name: 'OdemeAl',
    props:[
        "data",
    ],
    data() {
        return {
            paymnet_type:0,
            form: {
                tur:'b',
                currency: 'TRY',
                fx_amount: '',
                fx_rate: '',
                fx_kasa_id: null,
                amount: '',
            },
            receiptFile: null,
            banks:[],
            fxKasas:[],
            submitted: false,
            forex: {
                loading: false,
                rates: [],
                date: '',
                source: 'TCMB',
                error: '',
            },
        };
    },
    computed: {
        isNakit() {
            return String(this.paymnet_type) === '1'
        },
        isFx() {
            return this.isNakit && this.form.currency && this.form.currency !== 'TRY'
        },
        calculatedTl() {
            const amount = parseFloat(this.form.fx_amount)
            const rate = parseFloat(this.form.fx_rate)
            if (isNaN(amount) || isNaN(rate)) return null
            return (amount * rate).toFixed(2)
        },
        forexMeta() {
            if (!this.forex.date && !this.forex.source) return ''
            return [this.forex.date, this.forex.source].filter(Boolean).join(' · ')
        },
    },
    watch:{
        data(props){
            this.form = {
                ...props,
                currency: 'TRY',
                fx_amount: '',
                fx_rate: '',
                fx_kasa_id: null,
            }
            this.paymnet_type = 0
            this.banks = []
            this.fxKasas = []
            this.receiptFile = null
            this.fetchForexRates()
        },
        'form.currency'(val) {
            if (!this.isNakit || val === 'TRY') {
                this.resetFxFields()
                return
            }
            this.applyForexRate(val)
            this.loadFxKasas()
            this.calcTl()
        },
        'form.fx_amount'() { this.calcTl() },
        'form.fx_rate'() { this.calcTl() },
    },
    methods: {
        resetFxFields(){
            this.form.currency = 'TRY'
            this.form.fx_amount = ''
            this.form.fx_rate = ''
            this.form.fx_kasa_id = null
            this.fxKasas = []
        },

        calcTl(){
            if (!this.isFx) return
            if (this.calculatedTl !== null) this.form.amount = this.calculatedTl
        },

        applyForexRate(code){
            const rate = (this.forex.rates || []).find(r => r.code === code)
            if (rate && rate.value) {
                this.form.fx_rate = String(rate.value)
            }
        },

        fetchForexRates(refresh = false){
            this.forex.loading = true
            this.forex.error = ''
            const url = refresh ? '/dashboard/exchangeRates?refresh=1' : '/dashboard/exchangeRates'
            this.$http.get(url)
                .then((res) => {
                    this.forex.rates = res.data.rates || []
                    this.forex.date = res.data.date || ''
                    this.forex.source = res.data.source || 'TCMB'
                    if (this.isFx) {
                        this.applyForexRate(this.form.currency)
                        this.calcTl()
                    }
                })
                .catch(() => {
                    this.forex.error = 'Kurlar alınamadı'
                })
                .finally(() => {
                    this.forex.loading = false
                })
        },

        createPayment( { target }){
            this.paymnet_type = target.value
            this.getBanks(target.value)
            if (String(target.value) !== '1') {
                this.resetFxFields()
            } else if (this.isFx) {
                this.loadFxKasas()
            }
        },

         getBanks(paymnet_type){

            let type= 0;

            if( paymnet_type == 2)
            type = 'banka'
            else if( paymnet_type == 3)
            type = 'cek'
            else if( paymnet_type == 4)
            type = 'havale'

            if (!type) {
                this.banks = []
                return
            }

            this.$http.post(`safebank`,{ output:'only', type} )
            .then((resp) => this.banks = resp.data)
        },

        loadFxKasas(){
            this.$http.post(`safebank`,{ output:'only', type:'kasa', currency: this.form.currency })
            .then((resp) => {
                this.fxKasas = resp.data || []
                if (this.fxKasas.length === 1) this.form.fx_kasa_id = this.fxKasas[0].id
            })
        },

        payload(){
            const data = { ...this.form, paymnet_type: this.paymnet_type }
            if (!this.isFx) {
                data.currency = 'TRY'
                data.fx_amount = ''
                data.fx_rate = ''
                data.fx_kasa_id = null
            }
            return data
        },

        handleSubmit(){
            if (this.isFx) {
                if (!this.form.fx_amount || !this.form.fx_rate) {
                    notify.error('Döviz tutarı ve kur zorunludur.')
                    return
                }
                if (!this.form.fx_kasa_id) {
                    notify.error('Döviz kasası seçiniz.')
                    return
                }
            }
            if (!this.form.amount) {
                notify.error('Ödenen ücret zorunludur.')
                return
            }

            const body = this.payload()

            // Eğer Havale ve dekont seçilmişse FormData ile gönder
            if(this.paymnet_type == 4 && this.receiptFile){
                let fd = new FormData();
                for(const k in body){ fd.append(k, body[k] ?? ''); }
                fd.append('receipt', this.receiptFile);
                this.$http.post(`/dealers/${this.form.id}/balances/tahsilat`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(resp => notify.success(resp.data.message))
                .catch(()=> notify.error('Bir hata oluştu'));
                return;
            }

            this.$http.post(`/dealers/${this.form.id}/balances/tahsilat`, body)
            .then(resp => notify.success(resp.data.message))
        },

        onReceiptChange(e){
            const f = e.target.files && e.target.files[0];
            if(!f) return;
            const allowed = ['application/pdf','image/jpeg','image/jpg'];
            if(!allowed.includes(f.type)){
                notify.error('Sadece PDF veya JPG/JPEG dosya yükleyebilirsiniz.');
                e.target.value = '';
                this.receiptFile = null;
                return;
            }
            this.receiptFile = f;
        },

        close(){
            this.$parent.$bvModal.hide('tahsilat_modal')
        }
    },
};
</script>

<template>
<b-modal id="odeme_al"  :title="`Tahsilat Ekle > ${form.name}`"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="fx-box mb-3">
            <div class="fx-box__head">
                <div>
                    <strong><i class="bx bx-dollar-circle"></i> Döviz (TCMB)</strong>
                    <small v-if="forexMeta">{{ forexMeta }}</small>
                </div>
                <button type="button" class="fx-refresh" @click="fetchForexRates(true)" :disabled="forex.loading" title="Yenile">
                    <i class="bx bx-refresh" :class="{ 'bx-spin': forex.loading }"></i>
                </button>
            </div>
            <div class="fx-box__body" v-if="forex.loading">Kurlar yükleniyor...</div>
            <div class="fx-box__body fx-box__error" v-else-if="forex.error">{{ forex.error }}</div>
            <div class="fx-box__rates" v-else-if="forex.rates.length">
                <div class="fx-box__rate" v-for="rate in forex.rates" :key="rate.code">
                    <span>{{ rate.name || rate.code }}</span>
                    <strong>{{ rate.value }} ₺</strong>
                </div>
            </div>
            <div class="fx-box__body fx-box__error" v-else>Kurlar alınamadı</div>
        </div>

        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label">Ödeme Türü</label>
            <div class="col">
                <select class="form-select" @change="createPayment($event)">
                    <option value="">Seçiniz</option>
                    <option value="1">Nakit</option>
                    <option value="2">Kredi Kartı</option>
                    <option value="4">Havale</option>
                    <option value="3">Çek</option>
                </select>
            </div>
        </div>
         <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 2 || paymnet_type == 3 || paymnet_type == 4">
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-if="paymnet_type == 2">POS Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else-if="paymnet_type == 4">Havale Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else>Çek Bankası</label>
            <div class="col">
            <select class="form-select" v-model="form.credit_card_bank" id="bank">
                <option :value="bank.id" v-for="bank in banks" :key="bank.id">{{ bank.title }} </option>
            </select>
          </div>
        </div>
                <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 4">
                        <label class="col-sm-5 col-form-label" for="receipt">Dekont (PDF / JPG)</label>
                        <div class="col">
                                <input id="receipt" type="file" accept="application/pdf,image/jpeg,image/jpg" class="form-control" @change="onReceiptChange">
                        </div>
                </div>
        <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 2">
            <label class="col-sm-5 col-form-label col-form-label" for="interest">POS Faiz Oranı (%)</label>
            <div class="col">
                <input
                id="interest"
                v-model="form.credit_card_interest"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_giver_name">Çek Sahibi</label>
            <div class="col">
                <input
                id="cheque_giver_name"
                v-model="form.cheque_giver_name"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_number">Çek Numarası</label>
            <div class="col">
                <input
                id="cheque_number"
                v-model="form.cheque_number"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_date">Çek Tarihi</label>
            <div class="col">
                <input
                id="cheque_date"
                v-model="form.cheque_date"
                type="date"
                class="form-control"
                />
          </div>
        </div>
        <template v-if="isNakit">
            <div class="row d-flex flex-wrap mb-1">
                <label class="col-sm-5 col-form-label" for="currency">Döviz Cinsi</label>
                <div class="col">
                    <select id="currency" class="form-select" v-model="form.currency">
                        <option value="TRY">TL</option>
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                    </select>
                </div>
            </div>
            <template v-if="isFx">
                <div class="row d-flex flex-wrap mb-1">
                    <label class="col-sm-5 col-form-label" for="fx_kasa">Döviz Kasası</label>
                    <div class="col">
                        <select id="fx_kasa" class="form-select" v-model="form.fx_kasa_id">
                            <option :value="null">Seçiniz</option>
                            <option :value="kasa.id" v-for="kasa in fxKasas" :key="kasa.id">{{ kasa.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex flex-wrap mb-1">
                    <label class="col-sm-5 col-form-label" for="fx_amount">Döviz Tutarı</label>
                    <div class="col">
                        <input id="fx_amount" v-model="form.fx_amount" v-decimal type="text" class="form-control" :placeholder="form.currency" />
                    </div>
                </div>
                <div class="row d-flex flex-wrap mb-1">
                    <label class="col-sm-5 col-form-label" for="fx_rate">Kur</label>
                    <div class="col">
                        <input id="fx_rate" v-model="form.fx_rate" v-decimal type="text" class="form-control" placeholder="TCMB kuru" />
                        <small class="form-text text-muted">TCMB satış kuru otomatik doldurulur, gerekirse düzeltebilirsiniz.</small>
                    </div>
                </div>
            </template>
        </template>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-5 col-form-label col-form-label" for="amount">{{ isFx ? 'TL Karşılık' : 'Ödenen Ücret' }}</label>
            <div class="col">
                <input
                id="amount"
                v-model="form.amount"
                v-decimal
                type="text"
                class="form-control"
                />
                <small class="form-text text-muted" v-if="isFx">
                    Hesaplanan: {{ calculatedTl || '-' }} TL — bayiden düşülecek tutarı elle düzeltebilirsiniz.
                </small>
                <small class="form-text text-muted" v-else>Küsratı nokta (.) olarak girilecektir. Örn: 2859.99</small>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="explaine">Açıklama</label>
            <div class="col">
                <input
                id="explaine"
                v-model="form.explaine"
                type="text"
                class="form-control"
                />
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                >Ekle
            </b-button>
        </div>
    </form>
</b-modal>
</template>

<style scoped>
.fx-box {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  padding: 12px 14px;
}
.fx-box__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.fx-box__head strong {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #0f172a;
}
.fx-box__head small {
  display: block;
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
}
.fx-refresh {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.fx-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.fx-box__rates {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.fx-box__rate {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.fx-box__rate span {
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
}
.fx-box__rate strong {
  font-size: 13px;
  color: #0f172a;
}
.fx-box__body {
  font-size: 12px;
  color: #64748b;
}
.fx-box__error {
  color: #dc2626;
}
@media (max-width: 575.98px) {
  .fx-box__rates {
    grid-template-columns: 1fr;
  }
}
</style>
